import React from 'react'
import connect from 'libraries/front-end-core/decorators/connect'
import { requestLegislationKeyPicks } from 'services/LegislationService'
import KeyPicks from 'components/shared/KeyPicks'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { capitalize } from 'libraries/lodash'

const organizeKeyPicksByAOL = (keyPicks) => {
  const keyPicksByAOL = {
    corporate: [],
    employment: []
  }

  if (!keyPicks || !Array.isArray(keyPicks)) {
    return keyPicksByAOL
  }

  keyPicks.forEach(item => {
    if (item.aol && keyPicksByAOL[item.aol]) {
      keyPicksByAOL[item.aol].push(item)
    }
  })

  return keyPicksByAOL
}

const MultiAOLKeyPicks = (props) => {
  const { keyPicks, aol, ...restProps } = props

  // If we have a specific AOL, just render the normal KeyPicks component
  if (aol) {
    return <KeyPicks {...props} />
  }

  // Otherwise, organize by AOL sections
  const keyPicksByAOL = organizeKeyPicksByAOL(keyPicks)

  return (
    <div>
      {Object.entries(keyPicksByAOL).map(([aolType, items]) => {
        if (!items || items.length === 0) {
          return null
        }

        return (
          <div key={aolType} className='mb6'>
            <h3 className='f4 fw6 mb4 dark-orchid'>{capitalize(aolType)} Key Legislation</h3>
            <KeyPicks {...restProps} keyPicks={items} />
          </div>
        )
      })}
    </div>
  )
}

const ConnectedKeyPicks = connect(() => ({
  keyPicks: requestLegislationKeyPicks()
}))((props) => (
  <ResponseConsumer
    response={props.keyPicks}
    content={() => <MultiAOLKeyPicks {...props} />}
    pendingComponent={() => <KeyPicks {...props} pending />}
  />
))

export default ConnectedKeyPicks
